<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <section class="summary-left">
    <div>
      <h1 class="section-header">
        {{ APPEAL_SUMMARY_STATIC1 | globalTranslate }}
      </h1>
      <hr />
    </div>
    <p [innerHTML]="APPEAL_SUMMARY_STATIC2 | globalTranslate"></p>
    <div id="accordion">
      <!-- Appeal Request Information Table -->
      <div id="heading_1">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content">
            <div
              id="caratId_1"
              class="carat d-none d-lg-block"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_1" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC3
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_1" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC3 | globalTranslate
                  "
                ></i
              ></span>
            </div>
            <h2 id="headerButton_1" class="section-header ps-3" tabindex="0">
              {{ APPEAL_SUMMARY_STATIC3 | globalTranslate }}
            </h2>
            <div
              id="caratId_1"
              class="carat d-lg-none"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_1" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC3
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_1" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC3 | globalTranslate
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div
        id="collapse_1"
        class="collapse"
        aria-labelledby="heading_1"
        data-bs-parent="#accordion"
      >
        <div class="card-body d-none d-lg-block">
          <p>{{ APPEAL_SUMMARY_STATIC4 | globalTranslate }}</p>
          @if (appealRequestInformationArray?.length) {
          <table class="table table-bordered">
            <tbody class="thead-light text-start">
              @for (item of appealRequestInformationArray; track item; let i =
              $index) {
              <tr>
                <th scope="row">{{ item.key | globalTranslate }}</th>
                <td>{{ item.value | globalTranslate }}</td>
              </tr>
              }
            </tbody>
          </table>
          }
        </div>
        <div class="card-body nh-table-mobile d-lg-none">
          <p>{{ APPEAL_SUMMARY_STATIC4 | globalTranslate }}</p>
          @for (item of appealRequestInformationArray; track item; let i =
          $index) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ item.key | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">
              {{ item.value | globalTranslate }}
            </div>
          </div>
          }
        </div>
      </div>
      <!-- Appeal Demographics Table -->
      <div id="heading_2">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content">
            <div
              id="caratId_2"
              class="carat d-none d-lg-block"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_2" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC5
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_2" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC5 | globalTranslate
                  "
                ></i
              ></span>
            </div>
            <h2 id="headerButton_2" class="section-header ps-3" tabindex="0">
              {{ APPEAL_SUMMARY_STATIC5 | globalTranslate }}
            </h2>
            <div
              id="caratId_2"
              class="carat d-lg-none"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_2" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC5
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_2" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC5 | globalTranslate
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div
        id="collapse_2"
        class="collapse"
        aria-labelledby="heading_2"
        data-bs-parent="#accordion"
      >
        <div class="card-body d-none d-lg-block">
          <p>{{ APPEAL_SUMMARY_STATIC6 | globalTranslate }}</p>
          @if (appealDemographicsArray?.length) {
          <table class="table table-bordered">
            <tbody class="thead-light text-start">
              @for (item of appealDemographicsArray; track item; let i = $index)
              {
              <tr>
                <th scope="row">{{ item.key | globalTranslate }}</th>
                <td>{{ item.value | globalTranslate }}</td>
              </tr>
              }
            </tbody>
          </table>
          }
        </div>
        <div class="nh-table-mobile d-lg-none">
          <p>{{ APPEAL_SUMMARY_STATIC6 | globalTranslate }}</p>
          @for (item of appealDemographicsArray; track item; let i = $index) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ item.key | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">
              {{ item.value | globalTranslate }}
            </div>
          </div>
          }
        </div>
      </div>
      <!-- Appeal Details Table -->
      <div id="heading_3">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content">
            <div
              id="caratId_3"
              class="carat d-none d-lg-block"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_3" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC7
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_3" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC7 | globalTranslate
                  "
                ></i
              ></span>
            </div>
            <h2 id="headerButton_3" class="section-header ps-3" tabindex="0">
              {{ APPEAL_SUMMARY_STATIC7 | globalTranslate }}
            </h2>
            <div
              id="caratId_3"
              class="carat d-lg-none"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_3" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC7
                      | globalTranslate
                  "
                ></i></span
              ><span id="up_3" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                      ' ' +
                      APPEAL_SUMMARY_STATIC7 | globalTranslate
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div
        id="collapse_3"
        class="collapse"
        aria-labelledby="heading_3"
        data-bs-parent="#accordion"
      >
        <div class="card-body d-none d-lg-block">
          <p>{{ APPEAL_SUMMARY_STATIC8 | globalTranslate }}</p>
          @if (appealDetailsArray?.length) {
          <table class="table table-bordered">
            <tbody class="thead-light text-start">
              @for (item of appealDetailsArray; track item; let i = $index) {
              <tr>
                @if (i !== this.editKey && !item.coverageKey) {
                <th scope="col">{{ item.key | globalTranslate }}</th>
                } @if (i === this.editKey && !item.coverageKey) {
                <th scope="col">
                  {{ array[0] | globalTranslate
                  }}{{ array2[0] | globalTranslate
                  }}{{ array2[1] | globalTranslate }}
                </th>
                } @if (item.coverageKey) {
                <th scope="col">
                  {{ item.coverageKey | globalTranslate
                  }}{{ item.name | globalTranslate }}
                </th>
                }
                <td>{{ item.value | globalTranslate }}</td>
              </tr>
              }
            </tbody>
          </table>
          }
        </div>
        <div class="nh-table-mobile d-lg-none">
          <p>{{ APPEAL_SUMMARY_STATIC8 | globalTranslate }}</p>
          @for (item of appealDetailsArray; track item; let i = $index) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ item.key | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data text-wrap">
              {{ item.value | globalTranslate }}
            </div>
          </div>
          }
        </div>
      </div>
      <!-- Appeal Representative Details Table -->
      <div id="heading_4">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content">
            <div
              id="caratId_4"
              class="carat d-none d-lg-block"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_4" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC9
                  "
                ></i></span
              ><span id="up_4" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                    ' ' +
                    APPEAL_SUMMARY_STATIC9
                  "
                ></i
              ></span>
            </div>
            <h2 id="headerButton_4" class="section-header ps-3" tabindex="0">
              {{ APPEAL_SUMMARY_STATIC9 | globalTranslate }}
            </h2>
            <div
              id="caratId_4"
              class="carat d-lg-none"
              tabindex="0"
              role="button"
              (keydown.enter)="logInfo($event)"
              (keydown.space)="logInfo($event)"
            >
              <span id="dwn_4" class="cla2"
                ><i
                  class="fa fa-2x fa-angle-down"
                  [attr.aria-label]="
                    ('Expand' | globalTranslate) + ' ' + APPEAL_SUMMARY_STATIC9
                  "
                ></i></span
              ><span id="up_4" class="cla1"
                ><i
                  class="fa fa-2x fa-angle-up"
                  [attr.aria-label]="
                    ('Collapse' | globalTranslate) +
                    ' ' +
                    APPEAL_SUMMARY_STATIC9
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div
        id="collapse_4"
        class="collapse"
        aria-labelledby="heading_4"
        data-bs-parent="#accordion"
      >
        <div class="card-body d-none d-lg-block">
          @if (appealRepresentativeArray?.length) {
          <p>{{ APPEAL_SUMMARY_STATIC10 | globalTranslate }}</p>
          } @if (appealRepresentativeArray?.length) {
          <div>
            @for (item of appealRepresentativeArray; track item) {
            <div>
              <table class="table table-bordered">
                <tbody class="thead-light text-start">
                  @for (obj of item.request; track obj; let i = $index) {
                  <tr>
                    <th scope="col">{{ obj.key | globalTranslate }}</th>
                    <td>{{ obj.value | globalTranslate }}</td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            }
          </div>
          } @if (!appealRepresentativeArray?.length) {
          <p>{{ "APPEAL_SUMMARY_REP_EMPTYDATA" | globalTranslate }}</p>
          }
        </div>
        @if (appealRepresentativeArray?.length) {
        <div class="nh-table-mobile d-lg-none">
          <p>{{ APPEAL_SUMMARY_STATIC10 | globalTranslate }}</p>
          @for (item of appealRepresentativeArray; track item) {
          <div>
            @for (obj of item.request; track obj; let i = $index) {
            <div class="table-row mb-3 pb-3">
              <div class="mobile-table-header">
                {{ obj.key | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ obj.value | globalTranslate }}
              </div>
            </div>
            }
          </div>
          }
        </div>
        } @if (!appealRepresentativeArray?.length) {
        <p class="nh-table-mobile d-lg-none">
          {{ "APPEAL_SUMMARY_REP_EMPTYDATA" | globalTranslate }}
        </p>
        }
      </div>
    </div>
  </section>
</nh-form>